import React, { useState } from 'react';
import ResidentInfo from '../../components/MyProfile/ResidentInfo';
import './style.less';
import AllConnectedResidents from '../../components/MyProfile/AllConnectedResidents';
import WellnessTab from '../../components/MyProfile/WellnessTab';
import PasswordTab from '../../components/MyProfile/PasswordTab';
import NeighborsPayments from '../payments';
import { ProfileTab } from '../../types/MyProfile';

const MyProfile = () => {
    const [activeTab, setActiveTab] = useState<ProfileTab>('about');

    return (
        <div className="profile-page">
            <div className="profile-page-col profile-page-col--left">
                <AllConnectedResidents activeTab={activeTab} onTabChange={setActiveTab} />
            </div>
            <div className="profile-page-col profile-page-col--right">
                {activeTab === 'about' && <ResidentInfo />}
                {activeTab === 'wellness' && <WellnessTab />}
                {activeTab === 'password' && <PasswordTab />}
                {activeTab === 'payments' && <NeighborsPayments />}
            </div>
        </div>
    );
};

export default MyProfile;
